{
  "title": "Conversation Practice",
  "errors": {
    "load": "Couldn’t load practice",
    "start": "Couldn’t start practice. Please try again.",
    "sessionLoad": "Couldn’t load this session.",
    "reply": "Couldn’t get a reply. Please try again.",
    "payment": "Payment didn’t work",
    "packs": "Couldn’t load reply packs.",
    "summary": "Couldn’t create feedback.",
    "end": "Couldn’t end the session.",
    "clear": "Couldn’t clear the session.",
    "packsUnavailable": "Reply packs aren’t available right now."
  },
  "practiceAlert": "Practice",
  "tryAgain": "Please try again in a moment.",
  "tryAgainLater": "Please try again later.",
  "globalBalance_one": "Global reply balance: {{count}} practice reply left",
  "globalBalance_other": "Global reply balance: {{count}} practice replies left",
  "chooseScenario": "Choose a practice scenario",
  "chooseHint": "Tap to choose a scenario",
  "active": "Active",
  "byo": {
    "useOwn": "Use my own situation",
    "title": "Practise a real moment",
    "prompt": "What conversation would you like another go at?",
    "hint": "Think of a moment when you had the chance to use this skill but froze, avoided it, gave in, or said something you wish had gone differently.",
    "example": "For example: My friend kept pushing me to go out, and I agreed even though I wanted to say no.",
    "placeholder": "Describe what happened…",
    "send": "Send",
    "sending": "Setting the scene…",
    "starting": "Let’s begin…",
    "error": "Couldn’t set that up. Please try again."
  },
  "repliesFive": "You have 5 practice replies left.",
  "repliesTwo": "You have 2 practice replies left. Add more to keep practicing, or end with feedback.",
  "addRepliesTitle": "Practice Packs",
  "addRepliesBody": "Choose a pack. Purchased replies never expire.",
  "endTitle": "End practice?",
  "endBody": "This ends your session. You can still get feedback after.",
  "clearTitle": "Clear session?",
  "clearBody": "This permanently deletes this practice session and its messages.",
  "end": "End",
  "outOfReplies": "You’re out of practice replies. Add more to continue, or end with feedback.",
  "outOfRepliesShort": "You’re out of practice replies.",
  "addReplies": "Practice Packs",
  "endSummarize": "End & Get Feedback",
  "remaining_one": "You have {{count}} practice reply left.",
  "remaining_other": "You have {{count}} practice replies left.",
  "addMore": "Add more",
  "startNew": "Start New Practice",
  "finish": "Finish",
  "getSummary": "Get Feedback",
  "clearSession": "Clear Session",
  "balance": {
    "title": "Practice replies",
    "summary": "{{included}} plan · {{purchased}} purchased",
    "body": "Plan replies: {{included}} — they reset on {{date}}.\nPurchased replies: {{purchased}} — they never expire."
  },
  "outOfRepliesPlaceholder": "Out of replies",
  "replyPlaceholder": "Type your reply…",
  "dismissA11y": "Dismiss",
  "scenarios": {
    "break_ice": {
      "title": "Break the Ice",
      "description": "Practice opening naturally when there is a small shared moment.",
      "scene": "You're at a café and someone nearby seems open to a quick chat.",
      "goal": "Open naturally from a small shared moment.",
      "starters": {
        "1": "Hey, have you been here before? I'm trying to decide what to order.",
        "2": "Hi, I'm trying to be a little more social today, so I thought I'd say hello.",
        "3": "That looks good. Would you recommend it?"
      }
    },
    "keep_going": {
      "title": "Keep It Going",
      "description": "Practice turning a reply into a real back-and-forth.",
      "scene": "You've already said hello and the other person responded warmly: “Yeah, I come here sometimes. It's a nice spot to work for a bit.”",
      "goal": "Turn a reply into a balanced back-and-forth.",
      "starters": {
        "1": "Nice. Do you usually come here to work or just relax?",
        "2": "I can see why — it has a calm atmosphere.",
        "3": "I'm trying to find more places like this. Are there any others you like?"
      }
    },
    "repair_moment": {
      "title": "Repair a Moment",
      "description": "Practice clearing up awkward wording, missed cues, small tension, or misunderstandings.",
      "scene": "A small moment did not land quite right and you want to repair it calmly.",
      "goal": "Acknowledge what happened, keep it brief, and leave room for the other person.",
      "starters": {
        "1": "I think that came out differently than I meant. Can I reset that?",
        "2": "Sorry, I may have missed what you were saying. Can we go back to that?",
        "3": "I want to fix that without making it a big thing. What I meant was..."
      }
    },
    "set_boundary": {
      "title": "Set a Boundary",
      "description": "Practice saying no, slowing things down, or ending kindly.",
      "scene": "Someone is friendly, but the conversation is becoming more personal than you want.",
      "goal": "Say no, slow things down, or end kindly and clearly.",
      "starters": {
        "1": "I'm not comfortable sharing that, but I'm happy to talk about something lighter.",
        "2": "I'm going to head back to what I was doing, but it was nice chatting.",
        "3": "I'm going to pass for now. Take care."
      }
    },
    "make_plans_follow_up": {
      "title": "Make Plans & Follow Up",
      "description": "Practice suggesting a low-pressure next step, or sending a friendly follow-up after meeting.",
      "scene": "You had a short, friendly conversation earlier and want to suggest a next step or follow up.",
      "goal": "Suggest a low-pressure next step or send a friendly follow-up.",
      "starters": {
        "1": "It was nice chatting earlier. Would you be open to doing this again sometime?",
        "2": "Good meeting you today. No pressure, but I'd be up for a low-key follow-up.",
        "3": "Thanks for the chat earlier. Hope the rest of your day went well."
      }
    },
    "confidence": {
      "title": "Build Confidence",
      "description": "Practice one small social move when you are hesitant or unsure.",
      "scene": "You want to warm up before saying hello to someone.",
      "goal": "Try one small social move while feeling hesitant or unsure.",
      "starters": {
        "1": "Hi, how's your day going?",
        "2": "Hey, I'm trying to be a bit more social today, so I thought I'd say hello.",
        "3": "This feels a little awkward, but hi."
      }
    }
  },
  "packReplies_one": "{{count}} practice reply",
  "packReplies_other": "{{count}} practice replies",
  "ai": {
    "errorTemporary": "Conversation Practice is having trouble replying right now. Please try again.",
    "retry": "Try again",
    "thinking": "Thinking…",
    "noCredits": "You’re out of practice replies for now.",
    "rateLimited": "Please wait a moment before trying again.",
    "send": "Send",
    "stop": "Stop",
    "stopped": "Stopped"
  },
  "mode": {
    "guided": {
      "label": "Guided",
      "description": "Scene, starter options, and short feedback to keep you moving."
    },
    "roleplay": {
      "label": "Roleplay",
      "description": "Mostly in character, with light coaching when you ask."
    },
    "challenge": {
      "label": "Challenge",
      "description": "Fewer hints and more realistic replies. Still respectful."
    }
  },
  "modeIntro": {
    "label": "Welcome",
    "title": "Choose how you want to practice.",
    "body": "Pick a style first. The scenario will open based on what you choose.",
    "chooseA11y": "Choose {{mode}} practice"
  },
  "guided": {
    "scenarioLabel": "Scenario",
    "goalLabel": "Goal",
    "tryOneOfThese": "Try one of these:",
    "pickEditOrWrite": "Pick one, edit it, or write your own. I'll play the other person.",
    "writeMyOwn": "Write my own",
    "possibleNextReplies": "Possible next replies",
    "tryAnotherSetting": "Try another setting",
    "roleplayStart": "I'll play the other person. Start when you're ready.",
    "challengeStart": "Start the conversation."
  },
  "menu": {
    "title": "Menu",
    "mode": "Mode",
    "voice": "Voice",
    "balance": "Balance"
  },
  "voice": {
    "calm": "Calm",
    "warm": "Warm",
    "bright": "Bright",
    "grounded": "Grounded"
  },
  "continue": "Continue",
  "summary": {
    "title": "Practice Feedback",
    "mainTakeaway": "Main takeaway",
    "didWell": "You did well",
    "tryNext": "Try this next",
    "example": "Example",
    "realLife": "Take it into real life",
    "noPractice": {
      "title": "Nothing to summarise yet",
      "body": "Have a few exchanges in practice first, then Opncue can give you feedback based on what actually happened."
    },
    "tooShort": {
      "title": "A little more practice needed",
      "body": "There is not quite enough conversation yet for useful feedback. Try a few more exchanges and we’ll look for one clear strength and one useful next step."
    },
    "failure": {
      "title": "We couldn’t create your feedback",
      "body": "Your practice is still here. Try again in a moment.",
      "integrity": "We only show feedback when it can be based on what actually happened."
    },
    "loading": "Creating feedback from your practice…",
    "actions": {
      "continuePractice": "Continue practising",
      "keepPractising": "Keep practising",
      "retry": "Try feedback again",
      "return": "Return to practice",
      "practiseAgain": "Practise again",
      "anotherScenario": "Try another scenario",
      "done": "Done"
    }
  },
  "tip": {
    "label": "Practice tip"
  },
  "packPending": "Payment received. Your replies will appear in a moment."
}
